import { ghostBtnClass } from "./serviceShared";
import type { ServiceResourceAlertRow } from "./useServiceResourceNotesSummary";

export function ServiceBoardResourceNotesSummary(props: {
  alerts: ServiceResourceAlertRow[];
  onDismiss: (noteId: string) => void;
  dismissBusy?: boolean;
}) {
  const { alerts, onDismiss, dismissBusy } = props;
  if (alerts.length === 0) return null;

  return (
    <div className="rounded-xl border border-amber-200 bg-amber-50/90 px-4 py-3 dark:border-amber-900 dark:bg-amber-950/30">
      <div className="text-xs font-semibold uppercase tracking-wide text-amber-900 dark:text-amber-100">
        Resource alerts ({alerts.length})
      </div>
      <ul className="mt-2 space-y-2">
        {alerts.map(({ note, resourceLabel }) => (
          <li
            key={note.id}
            className="flex flex-wrap items-start justify-between gap-2 text-sm text-amber-950 dark:text-amber-50"
          >
            <div>
              <span className="font-medium">{resourceLabel}</span>
              <span className="text-amber-800 dark:text-amber-200"> — {note.body}</span>
              {note.expires_on ? (
                <span className="ml-1 text-xs text-amber-700 dark:text-amber-300">
                  (until {note.expires_on})
                </span>
              ) : null}
            </div>
            <button
              type="button"
              className={`${ghostBtnClass} shrink-0 text-xs`}
              disabled={dismissBusy}
              onClick={() => onDismiss(note.id)}
            >
              Dismiss
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
